import CheckoutTemplate from './templates/CheckoutTemplate'
import DefaultTemplate from './templates/DefaultTemplate'
import MyAccountTemplate from './templates/MyAccountTemplate'

export enum LayoutTemplateEnum {
  CHECKOUT = 'checkout',
  DEFAULT = 'default',
  MY_ACCOUNT = 'my-account',
}

export interface LayoutProps {
  template?: LayoutTemplateEnum
}

export function Layout({ template = LayoutTemplateEnum.DEFAULT }: LayoutProps) {
  switch (template) {
    case LayoutTemplateEnum.CHECKOUT:
      return <CheckoutTemplate />
    case LayoutTemplateEnum.MY_ACCOUNT:
      return <MyAccountTemplate />
    default:
      return <DefaultTemplate />
  }
}

export default Layout
